import { clsx } from "clsx"
import { type Key, useState } from "react"

import { type ImageProps, SuspenseImage } from "../Image/Image"
import { useCarousel } from "./Carousel"
import styles from "./CarouselItem.module.css"

export interface CarouselItemProps extends ImageProps {
  key: Key
  isUpdating?: boolean
  disableAnimation?: boolean
}

export function CarouselItem(props: CarouselItemProps) {
  const {
    alt,
    isUpdating = false,
    disableAnimation = false,
    ...otherProps
  } = props

  const [isLoaded, setIsLoaded] = useState(false)

  const loadingState = getLoadingState({ isLoaded, isUpdating })

  const { direction } = useCarousel()

  return (
    <div
      className={clsx(
        styles.root,
        styles[loadingState],
        // This animation sometimes causes a blink on render, so it can be disabled
        !disableAnimation && styles[`direction-${direction}`]
      )}
    >
      <SuspenseImage
        {...otherProps}
        alt={alt}
        sizing="contain"
        animateOnLoad={false}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  )
}

function getLoadingState(args: { isLoaded: boolean; isUpdating: boolean }) {
  const { isUpdating, isLoaded } = args

  if (isUpdating) return "updating"
  if (isLoaded) return "loaded"
  return "loading"
}
